/**
 * Console Security Warning
 * Displays a warning message in the browser console to prevent users
 * from accidentally pasting malicious code or sharing sensitive information
 */

// Import version from root package.json (monorepo single source of truth)
import { version } from '../../../package.json';

export const initConsoleWarning = () => {
  if (typeof window === 'undefined') return;

  // Main warning message (large text)
  const warningTitle = '%cStop!';
  const warningTitleStyle = [
    'color: #ff0000',
    'font-size: 48px',
    'font-weight: bold',
    'text-shadow: 2px 2px 4px rgba(0,0,0,0.5)',
  ].join(';');

  // Description message
  const warningMessage =
    "%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a MNX feature or \"hack\" someone's account, it is a scam and will give them access to your account.";

  const warningMessageStyle = [
    'color: #ff8c00',
    'font-size: 16px',
    'font-weight: normal',
    'line-height: 1.5',
  ].join(';');

  // Security note
  const securityNote =
    '%cDo not paste any code or paste any credentials here unless you understand exactly what you are doing.';
  const securityNoteStyle = [
    'color: #ff0000',
    'font-size: 14px',
    'font-weight: bold',
  ].join(';');

  // Display the warnings
  console.log(warningTitle, warningTitleStyle);
  console.log(warningMessage, warningMessageStyle);
  console.log(securityNote, securityNoteStyle);

  // Log application info (optional)
  console.log(
    '%cApplication Info:',
    'color: #0066cc; font-size: 14px; font-weight: bold;'
  );
  console.log(`Version: ${version}`);
  console.log('Environment: Production');
};

// Alternative: Prevent paste in console (advanced approach)
export const disableConsolePaste = () => {
  if (typeof window === 'undefined') return;

  // This detects if DevTools is open by checking if console is being used
  // and can display warnings when someone tries to paste
  const noop = () => {};
  const handler = {
    get: function (target: any, prop: string) {
      if (prop === 'log' || prop === 'warn' || prop === 'error') {
        // DevTools is open
        initConsoleWarning();
      }
      return noop;
    },
  };

  // Monitor console usage
  const consoleProxy = new Proxy({}, handler);
  (window as any).console = Object.assign(window.console, consoleProxy);
};
